"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const router_1 = require("@angular/router");
//VARIABLE MODELS
const login_service_1 = require("./login.service");
const branding_service_1 = require("./branding.service");
let LoginComponent = class LoginComponent {
    constructor(_login, _title, _route, _branding) {
        this._login = _login;
        this._title = _title;
        this._route = _route;
        this._branding = _branding;
        this._title.setTitle(this._branding.getProductSuiteTitle());
    }
    ngOnInit() {
        this._route.queryParams.forEach((params) => {
            if (params['authSource']) {
                this.authSource = params['authSource'];
            }
        });
    }
    loginKeypress(event) {
        if (event.keyCode == 13) {
            this.login({ email: this.email, password: this.password });
        }
    }
    login(loginBody) {
        this._login.login(loginBody, this.authSource);
    }
};
exports.LoginComponent = LoginComponent;
exports.LoginComponent = LoginComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-login',
        templateUrl: 'app/login.component.html',
        styleUrls: ['styles/login.component.css']
    }),
    __metadata("design:paramtypes", [login_service_1.LoginService,
        platform_browser_1.Title,
        router_1.ActivatedRoute,
        branding_service_1.BrandingService])
], LoginComponent);
//# sourceMappingURL=login.component.js.map